import { global } from ":global";
import type { ApiResponse } from "./_model";

export async function getRequests(): Promise<ApiResponse.GetRequests> {
  // return Promise.resolve(
  //   import("./get-requests.mocks").then((e) => {
  //     return Promise.resolve(e.success);
  //   })
  // );

  return global.api.getAuth("support/requests/").then((res) => {
    return res.data;
  });
}
